export const OWNER = 'owner'
export const ADMIN = 'admin'
export const MEMBER = 'member'
export const GUEST = 'guest'
